import { render, staticRenderFns } from "./script.vue?vue&type=template&id=c8cba0c6"
import script from "./script.vue?vue&type=script&lang=js"
export * from "./script.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports